var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItemPaperRequestsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.052,
    height: 19.865,
    viewBox: "0 0 17.052 19.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Paper-2",
    "data-name": "Paper",
    d: "M4.584,19.865A4.574,4.574,0,0,1,0,15.2V4.491A4.388,4.388,0,0,1,1.359,1.328,4.607,4.607,0,0,1,4.584.012h6.258a.758.758,0,0,1,.265,0h.13a.755.755,0,0,1,.541.23l5.064,5.276a.752.752,0,0,1,.21.52V15.2a4.634,4.634,0,0,1-4.479,4.661Zm0-18.353A3.073,3.073,0,0,0,1.5,4.491V15.2a3.194,3.194,0,0,0,.888,2.248,3.037,3.037,0,0,0,2.2.913h7.989a2.9,2.9,0,0,0,2.09-.946,3.269,3.269,0,0,0,.889-2.215V6.983l-.875,0-1.136,0a3.324,3.324,0,0,1-3.311-3.137l-.005-.188V1.511Zm7.141,2.147a1.824,1.824,0,0,0,1.82,1.824H14.73L11.724,2.353ZM5.387,14.307a.75.75,0,0,1-.1-1.493l.1-.006h5.4a.75.75,0,0,1,.1,1.493l-.1.006Zm0-4.952a.75.75,0,0,1-.1-1.493l.1-.007H8.743a.75.75,0,0,1,.1,1.493l-.1.007Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemPaperRequestsIcon);
export default __webpack_public_path__ + "static/media/menu-item-paper-requests-icon.9b2e20c3b141185bf7fc08fe113e6910.svg";
export { ForwardRef as ReactComponent };